/* ─────────────────────────────────────────────────────────────────────────────
   gb-scrollbar.js — cursore di scorrimento sempre visibile per i caroselli
   orizzontali del tema. Coppia di assets/gb-scrollbar.css.

   Per ogni contenitore che matcha SELECTOR:
     · nasconde la barra nativa (classe .gb-scrollbar-host),
     · inserisce subito dopo il contenitore una barra .gb-scrollbar con il suo
       cursore .gb-scrollbar__thumb,
     · tiene il cursore sincronizzato con scrollLeft e permette di trascinarlo
       (o di cliccare sulla traccia per saltare).

   La barra si nasconde solo se il contenuto non è scrollabile.
   I caroselli riempiti via JS (formati e pezzi speciali del variant explorer)
   cambiano contenuto senza cambiare dimensione: per questo, oltre al
   ResizeObserver, ogni host ha un MutationObserver sui figli.
   ───────────────────────────────────────────────────────────────────────────── */
(function () {
  var SELECTOR = [
    '.gb-carousel', // home, home brand, pagina collezione, pagina designer
    '.galleria__grid', // galleria immagini (collezione, progetto, pagine statiche)
    '.gbc-formats', // formati (variant explorer)
    '.gbc-special', // pezzi speciali (variant explorer)
    '.gbc-thumbs', // miniature della galleria variante
    '.gbvp-subtabs', // superfici Vogue Pool
  ].join(',');


  /* Aggiunge la navigazione a tutti i caroselli editoriali/fotografici.
     Formati e pezzi speciali System hanno gia' il proprio controller dedicato. */
  var RAIL_SELECTOR = '.galleria__grid, .gb-carousel';
  var nextRailId = 0;
  var language = (document.documentElement.lang || 'it').slice(0, 2).toLowerCase();
  var words = {
    it: { drag: 'Trascina per scorrere', touch: 'Scorri con il dito', prev: 'Scorri indietro', next: 'Scorri avanti' },
    en: { drag: 'Drag to browse', touch: 'Swipe to browse', prev: 'Scroll backward', next: 'Scroll forward' },
    fr: { drag: 'Glisser pour parcourir', touch: 'Balayer pour parcourir', prev: 'Faire défiler vers la gauche', next: 'Faire défiler vers la droite' },
    de: { drag: 'Zum Blättern ziehen', touch: 'Zum Blättern wischen', prev: 'Zurückblättern', next: 'Weiterblättern' }
  }[language] || null;
  if (!words) words = { drag: 'Drag to browse', touch: 'Swipe to browse', prev: 'Scroll backward', next: 'Scroll forward' };

  function enhanceRail(host) {
    if (!host.matches(RAIL_SELECTOR) || host.dataset.gbRailNav) return;
    host.dataset.gbRailNav = '1';
    if (!host.id) host.id = 'gb-image-rail-' + (++nextRailId);
    if (!host.hasAttribute('tabindex')) host.setAttribute('tabindex', '0');

    var tools = document.createElement('div');
    tools.className = 'gb-rail-tools';
    tools.hidden = true;
    var hint = document.createElement('span');
    hint.className = 'gb-rail-hint';
    hint.setAttribute('aria-hidden', 'true');
    var mouseText = document.createElement('span');
    mouseText.className = 'gb-rail-hint--mouse';
    mouseText.textContent = words.drag;
    var touchText = document.createElement('span');
    touchText.className = 'gb-rail-hint--touch';
    touchText.textContent = words.touch;
    hint.appendChild(mouseText);
    hint.appendChild(touchText);
    tools.appendChild(hint);

    var controls = document.createElement('div');
    controls.className = 'gb-rail-controls';
    function makeArrow(direction, label, glyph) {
      var button = document.createElement('button');
      button.type = 'button';
      button.setAttribute('aria-label', label);
      button.setAttribute('aria-controls', host.id);
      button.setAttribute('data-gb-rail-dir', String(direction));
      var sign = document.createElement('span');
      sign.setAttribute('aria-hidden', 'true');
      sign.textContent = glyph;
      button.appendChild(sign);
      button.addEventListener('click', function () { scrollStep(direction); });
      controls.appendChild(button);
      return button;
    }
    var prev = makeArrow(-1, words.prev, '‹');
    var next = makeArrow(1, words.next, '›');
    tools.appendChild(controls);
    host.insertAdjacentElement('beforebegin', tools);

    var dragging = null;
    var suppressClick = false;
    function refresh() {
      var max = host.scrollWidth - host.clientWidth;
      tools.hidden = max <= 3;
      prev.disabled = max <= 3 || host.scrollLeft < 3;
      next.disabled = max <= 3 || host.scrollLeft >= max - 3;
    }
    function scrollStep(direction) {
      var first = host.firstElementChild;
      var gap = parseFloat(window.getComputedStyle(host).columnGap) || 14;
      var step = first ? first.getBoundingClientRect().width + gap : host.clientWidth * 0.8;
      if (!step) return;
      var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      host.scrollBy({ left: direction * step, behavior: reduced ? 'auto' : 'smooth' });
    }

    prev.disabled = true;
    next.disabled = true;
    host.addEventListener('keydown', function (event) {
      if (event.target !== host) return; // preserva la tastiera di link e lightbox
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault();
        scrollStep(event.key === 'ArrowLeft' ? -1 : 1);
      }
    });

    /* Mouse: trascina anche partendo da una foto cliccabile o card-link.
       Soglia e soppressione click evitano di aprire lo zoom dopo un drag.
       Su mobile lasciamo integro lo swipe orizzontale nativo. */
    host.addEventListener('pointerdown', function (event) {
      if (event.pointerType !== 'mouse' || event.button !== 0 ||
          host.scrollWidth <= host.clientWidth + 3) return;
      dragging = { id: event.pointerId, x: event.clientX, left: host.scrollLeft, moved: false };
    });
    host.addEventListener('pointermove', function (event) {
      if (!dragging || dragging.id !== event.pointerId) return;
      var delta = event.clientX - dragging.x;
      if (!dragging.moved && Math.abs(delta) > 6) {
        dragging.moved = true;
        host.classList.add('gb-rail--dragging');
        host.setPointerCapture(event.pointerId);
      }
      if (dragging.moved) {
        event.preventDefault();
        host.scrollLeft = dragging.left - delta;
      }
    });
    function finishDrag(event) {
      if (!dragging || dragging.id !== event.pointerId) return;
      if (dragging.moved) {
        suppressClick = true;
        window.setTimeout(function () { suppressClick = false; }, 220);
      }
      dragging = null;
      host.classList.remove('gb-rail--dragging');
      refresh();
    }
    host.addEventListener('pointerup', finishDrag);
    host.addEventListener('pointercancel', finishDrag);
    host.addEventListener('lostpointercapture', finishDrag);
    host.addEventListener('dragstart', function (event) { event.preventDefault(); });
    host.addEventListener('click', function (event) {
      if (!suppressClick) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      suppressClick = false;
    }, true);

    host.addEventListener('scroll', refresh, { passive: true });
    if (window.ResizeObserver) new ResizeObserver(refresh).observe(host);
    if (window.MutationObserver) new MutationObserver(refresh).observe(host, { childList: true });
    window.addEventListener('resize', refresh, { passive: true });
    window.addEventListener('load', refresh, { once: true });
    refresh();
  }

  var MIN_THUMB = 28; // px: sotto questa larghezza il cursore non si afferra più

  function setup(host) {
    if (host.dataset.gbScrollbar) return;
    host.dataset.gbScrollbar = '1';
    host.classList.add('gb-scrollbar-host');

    var bar = document.createElement('div');
    bar.className = 'gb-scrollbar';
    var thumb = document.createElement('div');
    thumb.className = 'gb-scrollbar__thumb';
    bar.appendChild(thumb);
    host.insertAdjacentElement('afterend', bar);

    var thumbWidth = 0;

    function sync() {
      var max = host.scrollWidth - host.clientWidth;
      if (max <= 1) {
        bar.hidden = true;
        return;
      }
      // Da mostrare PRIMA di misurare la traccia: da nascosta la barra
      // misurerebbe 0 e non tornerebbe mai visibile.
      bar.hidden = false;
      var track = bar.clientWidth;
      if (track <= 0) {
        // Contenitore fuori dal flusso (antenato display:none): niente da fare
        // ora, il ResizeObserver richiamerà sync quando tornerà visibile.
        bar.hidden = true;
        return;
      }
      thumbWidth = Math.max(MIN_THUMB, Math.round(track * (host.clientWidth / host.scrollWidth)));
      thumbWidth = Math.min(thumbWidth, track);
      var x = (track - thumbWidth) * (host.scrollLeft / max);
      thumb.style.width = thumbWidth + 'px';
      thumb.style.transform = 'translateX(' + x + 'px)';
    }

    // Posiziona lo scroll in base al punto della traccia toccato.
    // grab = distanza tra il punto afferrato e il bordo sinistro del cursore.
    function seek(clientX, grab) {
      var track = bar.getBoundingClientRect();
      var span = track.width - thumbWidth;
      var max = host.scrollWidth - host.clientWidth;
      if (span <= 0 || max <= 0) return;
      var left = clientX - track.left - grab;
      host.scrollLeft = Math.min(Math.max(left / span, 0), 1) * max;
      // Riallinea subito il cursore senza aspettare l'evento scroll: lo
      // scroll-snap può correggere scrollLeft, e il cursore deve mostrare il
      // valore effettivo, non quello richiesto.
      sync();
    }

    var grabOffset = 0;

    bar.addEventListener('pointerdown', function (e) {
      if (bar.hidden) return;
      e.preventDefault();
      var thumbRect = thumb.getBoundingClientRect();
      var onThumb = e.clientX >= thumbRect.left && e.clientX <= thumbRect.right;
      grabOffset = onThumb ? e.clientX - thumbRect.left : thumbWidth / 2;
      bar.classList.add('is-dragging');
      bar.setPointerCapture(e.pointerId);
      seek(e.clientX, grabOffset);
    });
    bar.addEventListener('pointermove', function (e) {
      if (!bar.classList.contains('is-dragging')) return;
      e.preventDefault();
      seek(e.clientX, grabOffset);
    });
    ['pointerup', 'pointercancel'].forEach(function (type) {
      bar.addEventListener(type, function (e) {
        bar.classList.remove('is-dragging');
        if (bar.hasPointerCapture && bar.hasPointerCapture(e.pointerId)) bar.releasePointerCapture(e.pointerId);
      });
    });

    host.addEventListener('scroll', sync, { passive: true });

    if (window.ResizeObserver) {
      var ro = new ResizeObserver(sync);
      ro.observe(host);
      ro.observe(bar);
    }
    if (window.MutationObserver) {
      new MutationObserver(sync).observe(host, { childList: true, subtree: true });
    }
    window.addEventListener('resize', sync);
    // Le card caricano immagini lazy: rimisura quando arrivano.
    window.addEventListener('load', sync);

    enhanceRail(host);
    sync();
  }

  function scan() {
    document.querySelectorAll(SELECTOR).forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  // Theme editor: una sezione ricaricata porta caroselli nuovi.
  document.addEventListener('shopify:section:load', scan);
})();
